import script from "./AskPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./AskPrice.vue?vue&type=script&setup=true&lang=js"

import "./AskPrice.vue?vue&type=style&index=0&id=e598fb0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e598fb0a"]])

export default __exports__